module.exports = __webpack_public_path__ + "static/img/tcqn4.a0493bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/tcqn4.png
// module id = 383
// module chunks = 0